// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getCardId } = require('utilities/commercialAdsHelper');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { CardSelectorItem } = require('components/cards/cardSelectorRadioButton/cardSelectorItem');

class CardPaymentPurchaseDeferralSelectCreditCard extends React.PureComponent {
    renderContent = () => {
        const { immCard, immCommercialAds } = this.props;
        let content = <LoadingSection />;

        if (!!immCard && !immCommercialAds.get('isFetching')){
            const commercialId = getCardId(immCard);
            const commercialAd = immCommercialAds.getIn(['byId', commercialId]);
            const commercialAdToJs = !!commercialAd ? commercialAd.toJS() : null;

            content = (
                <CardSelectorItem
                    key={0}
                    card={immCard.toJS()}
                    active={true}
                    index={0}
                    commercialAd={commercialAdToJs}
                />
            );

        }

        return content;
    }

    render() {
        const title = formatText("cardPaymentReferral-cardSelectorTitle");

        return (
            <section>
                <h3><FormattedText value={"cardPaymentReferral-cardsTitle"} /></h3>
                <FormattedText value={"cardPaymentReferral-cardsText"} />
                <div className="row">
                    <div className="col-md-12 card-selector-radio-button">
                        <h5 className="card-selector-radio-button__title">{title}</h5>
                        {this.renderContent()}
                    </div>
                </div>
            </section>
        )
    }
}

CardPaymentPurchaseDeferralSelectCreditCard.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object,
    lavandaEnabled: PropTypes.object.isRequired,
};

module.exports.constructor = CardPaymentPurchaseDeferralSelectCreditCard;
module.exports.CardPaymentPurchaseDeferralSelectCreditCard = connect(
	state => ({
        immCommercialAds: state.commercialAds,
	}), {})(CardPaymentPurchaseDeferralSelectCreditCard);
